// Kopf der Opportunity-Seiten: Titel, Umschalter Pipeline/Liste (nimmt die Filter mit), Link kopieren, „Opportunity“ neu.
import { NavLink } from "react-router-dom";
import { Icon } from "../components/Icon";
import { useMeldung } from "../components/Meldungen";
import { kopieren } from "../werkzeuge/tasten";
import { suchparameterBehalten } from "./zustand";

interface Props {
  titel: string;
  suche: string;
  onNeu: () => void;
}

export function OpportunityKopf({ titel, suche, onNeu }: Props) {
  const meldung = useMeldung();
  const behalten = suchparameterBehalten(suche);
  const umschalter = ({ isActive }: { isActive: boolean }) => `segment__knopf${isActive ? " segment__knopf--an" : ""}`;
  return (
    <div className="liste-kopf">
      <h1 className="liste-kopf__titel">{titel}</h1>
      <div className="liste-kopf__rechts">
        <nav className="segment opp-kopf__umschalter" aria-label="Ansicht">
          <NavLink to={`/opportunities${behalten}`} end className={umschalter}>
            Pipeline
          </NavLink>
          <NavLink to={`/opportunities/liste${behalten}`} className={umschalter}>
            Liste
          </NavLink>
        </nav>
        <button
          type="button"
          className="symbolknopf symbolknopf--rand"
          title="Link zu dieser Ansicht kopieren (mit Filtern)"
          aria-label="Link zu dieser Ansicht kopieren"
          onClick={async () => {
            if (await kopieren(window.location.href)) meldung.ok("Link kopiert.");
            else meldung.zeige("fehler", "Kopieren hat nicht geklappt.");
          }}
        >
          <Icon name="link" groesse={14} />
        </button>
        <button type="button" className="knopf knopf--primaer" onClick={onNeu}>
          <Icon name="plus" groesse={14} />
          Opportunity
        </button>
      </div>
    </div>
  );
}
